import { LOCATIONS } from "consts";
import { getLocations } from "api";

export async function guessLocation(preferredLocation, user) {
    const locations = await getLocations(false, false);

    if (preferredLocation) {
        const preferredLocations = locations.filter(
            (location) => location.key === preferredLocation
        );

        if (preferredLocations?.length === 1) {
            return preferredLocations[0];
        }
    }

    if (user.location) {
        return user.location;
    }

    return locations.find((location) => location.key === LOCATIONS.POLAND);
}